import { useCallback, useEffect } from 'react';
import { useWebViewPostMessage, EventName } from '@digitaz/bridge-sdk-client';
import {
  PaymentStatusMessageParams,
  parsePaymentReturnMessage
} from '../utils/helpers/paymentStatusMessage';

type PaymentStatusHandler = (params: PaymentStatusMessageParams) => void;

export default function usePaymentStatusPostMessage(
  handler: PaymentStatusHandler
) {
  const stableHandler = useCallback(handler, [handler]);

  useWebViewPostMessage({
    eventName: EventName.PaymentStatus,
    handler: stableHandler
  });

  useEffect(() => {
    const handleEvent = (event: MessageEvent) => {
      const params = parsePaymentReturnMessage(event.data);

      if (params?.status) {
        stableHandler(params);
      }
    };

    window.addEventListener('message', handleEvent, true);
    return () => window.removeEventListener('message', handleEvent, true);
  }, [stableHandler]);
}
